module.exports = __webpack_public_path__ + "static/img/3.c3fba4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/3.jpg
// module id = Umfv
// module chunks = 1